<template>
    <div class="page-wrapper">
        <Header/>
        <div class="wrapper">
            <div class="page calculation-page">
                <div class="container">
                    <div class="page-title visibility">
                        <span>Рассчитать карту</span>
                        <div class="save-astro-map-block" v-if="!!userLoggedIn">
                            <input type="text" autocomplete="off" required="required" placeholder="Название карты"
                                   v-model="astroMap.name">
                            <button class="small-button blue-button"
                                    :disabled="!canSaveAstroMap"
                                    @click="saveAstroMap">Сохранить карту
                            </button>
                        </div>
                    </div>

                    <natal-input
                            :show-additional-maps="true"/>

                    <div class="tables-astro-wrapper"
                         :class="astroWrapperClass"
                         v-if="swephData">

                        <div class="tables-astro-info-wrapper"
                             v-if="!!userLoggedIn"
                             v-show="additionalMapMode !== modes.multimap">
                            <div class="table-astro-info">
                                <div class="table-astro-info-col">
                                    <div class="info-item"><span>Тип:</span>
                                        <span>{{getAstroType(swephData.type)}}</span>
                                    </div>
                                </div>
                                <div class="table-astro-info-col">
                                    <div class="info-item">
                                        <span>Профиль:</span> <span>{{swephData.profile}}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="table-astro-select">
                                <ul>
                                    <li>
                                        <label>
                                            <input type="checkbox" class="calc-select-natal"
                                                   v-model="drawAstroCircle">Натальная карта
                                        </label>
                                        <ul class="calc-select-natal-dp"
                                            :class="{'block-hidden' : !drawAstroCircle}">
                                            <li><label><input type="checkbox"
                                                              v-model="drawMode.astroCircle.natal">Личность</label>
                                            </li>
                                            <li><label><input type="checkbox"
                                                              v-model="drawMode.astroCircle.design">Дизайн</label>
                                            </li>
                                            <li v-if="!!additionalMapMode">
                                                <label v-show="additionalMapMode === modes.transit">
                                                    <input type="checkbox"
                                                           v-model="drawMode.astroCircle.transit">Транзит</label>
                                                <label v-show="additionalMapMode === modes.direction">
                                                    <input type="checkbox"
                                                           v-model="drawMode.astroCircle.direction">Дирекция</label>
                                                <label v-show="additionalMapMode === modes.progression">
                                                    <input type="checkbox"
                                                           v-model="drawMode.astroCircle.progression">Прогрессия</label>
                                            </li>
                                        </ul>
                                    </li>
                                    <li>
                                        <label>
                                            <input type="checkbox" class="calc-select-bodygraph"
                                                   v-model="drawBodygraph">Бодиграф
                                        </label>
                                        <ul class="calc-select-bodygraph-dp"
                                            :class="{'block-hidden' : !drawBodygraph}">
                                            <li><label><input type="checkbox"
                                                              v-model="drawMode.bodygraph.natal">Личность</label>
                                            </li>
                                            <li><label><input type="checkbox"
                                                              v-model="drawMode.bodygraph.design">Дизайн</label>
                                            </li>
                                            <li v-if="!!additionalMapMode">
                                                <label v-show="additionalMapMode === modes.transit">
                                                    <input type="checkbox"
                                                           v-model="drawMode.bodygraph.transit">Транзит</label>
                                                <label v-show="additionalMapMode === modes.direction">
                                                    <input type="checkbox"
                                                           v-model="drawMode.bodygraph.direction">Дирекция</label>
                                                <label v-show="additionalMapMode === modes.progression">
                                                    <input type="checkbox"
                                                           v-model="drawMode.bodygraph.progression">Прогрессия</label>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div class="map-table-natal-wrapper">
                            <!-- Обычный режим (карта + бодиграф) -->

                            <!-- Органы управления для бесплатного тарифа -->
                            <div class="tables-astro-info-wrapper"
                                 v-if="!userLoggedIn">
                                <div class="table-astro-select">
                                    <ul>
                                        <li>
                                            <label>
                                                <input type="radio" name="select-map" class="calc-select-natal"
                                                       :value="freeDrawModes.astroCircle"
                                                       v-model="freeDrawMode">Натальная карта
                                            </label>
                                            <ul class="calc-select-natal-dp"
                                                :class="{'block-hidden' : freeDrawMode != freeDrawModes.astroCircle}">
                                                <li><label><input type="checkbox"
                                                                  v-model="drawMode.astroCircle.natal">Личность</label>
                                                </li>
                                                <li><label><input type="checkbox"
                                                                  v-model="drawMode.astroCircle.design">Дизайн</label>
                                                </li>
                                            </ul>
                                        </li>
                                        <li>
                                            <label>
                                                <input type="radio" name="select-map" class="calc-select-bodygraph"
                                                       :value="freeDrawModes.bodygraph"
                                                       v-model="freeDrawMode">Бодиграф
                                            </label>
                                            <ul class="calc-select-bodygraph-dp"
                                                :class="{'block-hidden' : freeDrawMode != freeDrawModes.bodygraph}">
                                                <li><label><input type="checkbox"
                                                                  v-model="drawMode.bodygraph.natal">Личность</label>
                                                </li>
                                                <li><label><input type="checkbox"
                                                                  v-model="drawMode.bodygraph.design">Дизайн</label>
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>

                                    <div class="notice-need-tariff">
                                        <router-link :to="{name: 'Registration'}">Зарегистрируйтесь</router-link>
                                        чтобы строить натальную карту, бодиграф и транзиты бесплатно на одной карте.
                                    </div>

                                </div>
                            </div>
                            <div class="map-natal-wrapper"
                                 v-if="additionalMapMode !== modes.multimap">
                                <astro-circle v-show="drawAstroCircle"
                                              :draw-mode="drawMode.astroCircle"
                                              :sweph-data="swephData"/>

                                <bodygraph v-show="drawBodygraph"
                                           :draw-mode="drawMode.bodygraph"
                                           :gate-modes="swephData.gateModes"
                                           :determined-centers="swephData.determinedCenters"/>
                            </div>


                            <div class="multimap-map-list"
                                 v-if="!!proTariff && additionalMapMode === modes.multimap">
                                <div class="multimap-map-item"
                                     v-if="swephData.directionPositions">
                                    <div class="multimap-map-title">Дирекция</div>
                                    <div class="map-natal-wrapper">
                                        <astro-circle :draw-mode="getMulticardDrawMode(modes.direction)"
                                                      :sweph-data="swephData"/>
                                    </div>
                                    <aspect-table
                                            class="add-map-direction"
                                            :mode="modes.direction"
                                            :planet-aspects="swephData.natalDirectionAspects"/>
                                </div>
                                <div class="multimap-map-item"
                                     v-if="swephData.progressionPositions">
                                    <div class="multimap-map-title">Прогрессия</div>
                                    <div class="map-natal-wrapper">
                                        <astro-circle :draw-mode="getMulticardDrawMode(modes.progression)"
                                                      :sweph-data="swephData"/>
                                    </div>
                                    <aspect-table
                                            class="add-map-progression"
                                            :mode="modes.progression"
                                            :planet-aspects="swephData.natalProgressionAspects"/>
                                </div>
                                <div class="multimap-map-item"
                                     v-if="swephData.transitPositions">
                                    <div class="multimap-map-title">Транзит</div>
                                    <div class="map-natal-wrapper">
                                        <astro-circle :draw-mode="getMulticardDrawMode(modes.transit)"
                                                      :sweph-data="swephData"/>
                                    </div>
                                    <aspect-table
                                            class="add-map-transit"
                                            :mode="modes.transit"
                                            :planet-aspects="swephData.natalTransitAspects"/>
                                </div>
                                <div class="multimap-map-item"
                                     v-if="swephData.natalPositions">
                                    <div class="multimap-map-title">Натал</div>
                                    <div class="map-natal-wrapper">
                                        <astro-circle :draw-mode="getMulticardDrawMode(modes.natal)"
                                                      :sweph-data="swephData"/>
                                    </div>
                                    <aspect-table
                                            :mode="modes.natal"
                                            :planet-aspects="swephData.natalAspects"/>
                                </div>
                            </div>

                            <div class="table-dip-wrapper"
                                 v-if="!!userLoggedIn">
                                <div class="dynamic-wrapper">
                                    <date-dynamic
                                            :mode="modes.natal"/>
                                    <date-dynamic
                                            :mode="modes.transit"
                                            v-show="additionalMapMode === modes.transit"/>
                                    <date-dynamic
                                            :mode="modes.direction"
                                            v-show="additionalMapMode === modes.direction"/>
                                    <date-dynamic
                                            :mode="modes.progression"
                                            v-show="additionalMapMode === modes.progression"/>
                                    <date-dynamic
                                            :mode="modes.multimap"
                                            v-if="!!proTariff"
                                            v-show="additionalMapMode === modes.multimap"/>
                                </div>

                                <div class="table-dip">
                                    <natal-design-table
                                            :mode="modes.natal"
                                            :planet-positions="swephData.natalPositions"
                                            v-show="additionalMapMode !== modes.multimap"/>
                                    <natal-design-table
                                            :mode="modes.design"
                                            :planet-positions="swephData.designPositions"
                                            v-show="additionalMapMode !== modes.multimap"/>
                                    <natal-design-table
                                            :mode="modes.transit"
                                            :planet-positions="swephData.transitPositions"
                                            v-show="additionalMapMode === modes.transit"/>
                                    <natal-design-table
                                            :mode="modes.direction"
                                            :planet-positions="swephData.directionPositions"
                                            v-show="additionalMapMode === modes.direction"/>
                                    <natal-design-table
                                            :mode="modes.progression"
                                            :planet-positions="swephData.progressionPositions"
                                            v-show="additionalMapMode === modes.progression"/>
                                </div>
                            </div>

                            <template v-if="!!userLoggedIn">
                                <aspect-table
                                        :mode="modes.natal"
                                        :planet-aspects="swephData.natalAspects"
                                        v-show="!additionalMapMode"/>
                                <aspect-table
                                        :mode="modes.transit"
                                        :planet-aspects="swephData.natalTransitAspects"
                                        v-show="additionalMapMode === modes.transit"
                                        v-if="!!swephData.natalTransitAspects"/>
                                <aspect-table
                                        :mode="modes.direction"
                                        :planet-aspects="swephData.natalDirectionAspects"
                                        v-show="additionalMapMode === modes.direction"
                                        v-if="!!swephData.natalDirectionAspects"/>
                                <aspect-table
                                        :mode="modes.progression"
                                        :planet-aspects="swephData.natalProgressionAspects"
                                        v-show="additionalMapMode === modes.progression"
                                        v-if="!!swephData.natalProgressionAspects"/>
                            </template>

                            <firdar-table
                                    :firdar-data="swephData.firdars"
                                    :timezone-id="swephData.natalZoneId"
                                    v-if="!!currentSubscription"
                                    v-show="additionalMapMode !== modes.multimap"/>
                        </div>

                    </div>
                </div>
            </div>
            <div class="page-buffer"></div>
        </div>
        <Footer/>
    </div>
</template>

<script>
    import constants from '@/constants';
    import utils from '@/utils';
    import moment from 'moment';
    import Header from '@/components/Header';
    import Footer from '@/components/Footer';
    import NatalInput from '@/components/NatalInput';
    import AstroCircle from '@/components/AstroCircle';
    import Bodygraph from '@/components/Bodygraph';
    import AspectTable from '@/components/AspectTable';
    import DateDynamic from '@/components/DateDynamic';
    import NatalDesignTable from "@/components/NatalDesignTable";
    import FirdarTable from "@/components/FirdarTable";

    const emptyAstroMap = {
        id: null,
        name: ''
    };

    const freeDrawModes = {
        astroCircle: 1,
        bodygraph: 2
    };

    export default {
        name: "CardCalculate",

        components: {
            Header, Footer, NatalInput, AstroCircle, Bodygraph, AspectTable, DateDynamic, NatalDesignTable, FirdarTable
        },

        data() {
            return {
                astroMap: Object.assign({}, emptyAstroMap),

                drawAstroCircle: true,
                drawBodygraph: false,

                drawMode: {
                    astroCircle: {
                        natal: true,
                        design: true,
                        transit: false,
                        direction: false,
                        progression: false
                    },

                    bodygraph: {
                        natal: true,
                        design: true,
                        transit: false,
                        direction: false,
                        progression: false
                    }
                },

                freeDrawModes: freeDrawModes,
                freeDrawMode: freeDrawModes.astroCircle
            }
        },

        computed: {
            modes() {
                return constants.mode;
            },

            swephData() {
                return this.$store.getters.swephData;
            },

            inputDate: {
                get() {
                    return this.$store.getters.inputDate;
                },

                set(val) {
                    this.$store.commit('setInputDate', val);
                }
            },

            inputTime: {
                get() {
                    return this.$store.getters.inputTime;
                },

                set(val) {
                    this.$store.commit('setInputTime', val);
                }
            },

            inputCity: {
                get() {
                    return this.$store.getters.inputCity;
                },

                set(val) {
                    this.$store.commit('setInputCity', val);
                }
            },

            additionalMapMode() {
                let mode = this.$store.getters.additionalMapMode;
                if (!!mode && !!this.swephData && (
                    (mode === constants.mode.transit
                        && !!this.swephData.transitPositions
                        && this.swephData.transitPositions.length > 0)
                    || (mode === constants.mode.direction
                        && !!this.swephData.directionPositions
                        && this.swephData.directionPositions.length > 0)
                    || (mode === constants.mode.progression
                        && !!this.swephData.progressionPositions
                        && this.swephData.progressionPositions.length > 0)
                    || mode === constants.mode.multimap
                )) {
                    return mode;
                } else
                    return null;
            },

            userLoggedIn() {
                let token = this.$store.getters.token;
                return !!token && token.length > 0;
            },

            currentSubscription() {
                return this.$store.getters.currentSubscription;
            },

            proTariff() {
                return this.$store.getters.proTariff;
            },

            astroWrapperClass() {
                return {
                    'calculate-tariff-paid': !!this.currentSubscription,
                    'calculate-tariff-free': !this.userLoggedIn,
                    'add-map-transit': this.additionalMapMode === constants.mode.transit,
                    'add-map-direction': this.additionalMapMode === constants.mode.direction,
                    'add-map-progression': this.additionalMapMode === constants.mode.progression,
                    'add-map-multimap': this.additionalMapMode === constants.mode.multimap
                };

            },

            canSaveAstroMap() {
                return !!this.userLoggedIn
                    && !!this.astroMap.name
                    && !!this.inputDate
                    && !!this.inputTime
                    && !!this.inputCity && this.inputCity.lat != null && this.inputCity.lng != null;
            },


        },



        watch: {
            userLoggedIn(val) {
                if (!!val) {
                    this.$store.dispatch('getCurrentSubscription');
                }
            },

            currentSubscription(val) {
                if (!val)
                    return;

                // Инициализируем видимость переключателей для платного тарифа
                this.drawAstroCircle = true;
                this.drawBodygraph = true;

                Object.assign(this.drawMode.astroCircle, {
                    natal: true,
                    design: true,
                    transit: false
                });
                Object.assign(this.drawMode.bodygraph, {
                    natal: true,
                    design: true,
                    transit: false
                });
            },

            /** В транзитном режиме для бесплатного тарифа отображается только транзит на астральной карте */
            freeDrawMode(val) {
                if (!val)
                    return;

                switch (val) {
                    case freeDrawModes.astroCircle:
                        this.drawAstroCircle = true;
                        this.drawBodygraph = false;
                        Object.assign(this.drawMode.astroCircle, {
                            natal: true,
                            design: true
                        });
                        break;
                    case freeDrawModes.bodygraph:
                        this.drawAstroCircle = false;
                        this.drawBodygraph = true;
                        Object.assign(this.drawMode.bodygraph, {
                            natal: true,
                            design: true
                        });
                        break;
                }
            }
        },

        async created() {
            if (!!this.userLoggedIn) {
                this.$store.dispatch('getCurrentSubscription');

                let astroMapId = Number(this.$route.query.id);

                if (astroMapId > 0) {
                    await this.loadAstroMap(astroMapId);
                } else if (!this.inputDate
                    && !this.inputTime
                    && !this.inputCity) {
                    this.loadUserData();
                }
            } else {
                this.deleteIdFromQuery();
            }
        },

        methods: {
            getAstroType(type) {
                return constants.typeNames.get(type);
            },

            getAstroAuthority(authority) {
                return constants.authorityNames.get(authority);
            },

            getAstroProfile(profile) {
                return constants.profiles.get(profile);
            },

            getMulticardDrawMode(mode) {
                return {
                    natal: mode == constants.mode.natal,
                    design: mode == constants.mode.design,
                    transit: mode == constants.mode.transit,
                    direction: mode == constants.mode.direction,
                    progression: mode == constants.mode.progression
                }
            },

            deleteIdFromQuery() {
                let query = Object.assign({}, this.$route.query);
                delete query.id;
                this.$router.replace({query});
            },

            setInputDateTimeByUnixTime(birthday) {
                if (!birthday)
                    return;

                this.inputDate = moment(birthday).set({
                    hour: 0,
                    minute: 0,
                    second: 0,
                    millisecond: 0
                }).format("DD.MM.YYYY");
                this.inputTime = moment(birthday).format("HH:mm");
            },

            async loadUserData() {
                let currentUser = this.$store.getters.currentUser;
                if (!!currentUser) {
                    this.resetPage();

                    this.inputCity = currentUser.birthAddress;
                    this.setInputDateTimeByUnixTime(currentUser.birthday);
                }
            },

            async loadAstroMap(id) {
                if (!id)
                    return;

                let astroMap = await this.$store.dispatch("getAstroMap", id);
                if (!astroMap) {
                    this.deleteIdFromQuery();
                    return;
                }
                this.resetPage();

                this.astroMap.id = id;
                this.astroMap.name = astroMap.name;

                this.inputCity = astroMap.address;
                this.setInputDateTimeByUnixTime(astroMap.birthday);

                if (utils.validateNatalInputData(this.inputDate, this.inputTime, this.inputCity))
                    await this.$store.dispatch("loadSwephData");
            },

            async saveAstroMap() {
                if (!this.canSaveAstroMap)
                    return;

                let birthday = utils.getUnixTimeOfBirthdateAndTime(this.inputDate, this.inputTime);
                let data = {
                    name: this.astroMap.name,
                    birthday: birthday,
                    address: this.inputCity
                };

                let astroMap = !!this.astroMap.id ?
                    await this.$store.dispatch('updateAstroMap', [this.astroMap.id, data]) :
                    await this.$store.dispatch('createAstroMap', data);

                if (astroMap != null) {
                    alert('Карта была сохранена');
                    this.$router.push({name: 'CardCalculate', query: {id: astroMap.id}})
                }
            },

            resetPage() {
                this.$store.dispatch('clearSweph');
                this.astroMap = Object.assign({}, emptyAstroMap);
            }
        },

        destroyed() {
            this.$store.commit('setCalculateMapFromIndexPage', false);
            this.resetPage();
        }
    }
</script>